import { render, staticRenderFns } from "./IcoOrganizationCapability.vue?vue&type=template&id=0d3c81d3"
import script from "./IcoOrganizationCapability.vue?vue&type=script&lang=js"
export * from "./IcoOrganizationCapability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports